import { render, staticRenderFns } from "./ComponentIcons.vue?vue&type=template&id=e224a7cc&scoped=true&"
import script from "./ComponentIcons.vue?vue&type=script&lang=js&"
export * from "./ComponentIcons.vue?vue&type=script&lang=js&"
import style0 from "./ComponentIcons.vue?vue&type=style&index=0&id=e224a7cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e224a7cc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e224a7cc')) {
      api.createRecord('e224a7cc', component.options)
    } else {
      api.reload('e224a7cc', component.options)
    }
    module.hot.accept("./ComponentIcons.vue?vue&type=template&id=e224a7cc&scoped=true&", function () {
      api.rerender('e224a7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/ComponentIcons.vue"
export default component.exports